// Foundations
import {
  Component,
  ElementRef,
  HostBinding,
  OnInit,
  ViewChild,
} from '@angular/core';

// rxjs
import { forkJoin, Observable } from 'rxjs';
import { filter, map, take, finalize, skip } from 'rxjs/operators';

// models
import { FranchiseLocation } from '@app/models/franchise.model';
import { ParsedPet } from '@app/models/pet/pet.model';

// Services
import { PetService } from '@app/services/pet.service';
import {
  GetMarketingTilesGQL,
  MarketingTile,
} from '@app/services/graphql.service';
import { AnalyticsService } from '@app/services/analytics.service';
import { MyProfileService } from '@app/services/my-profile.service';
import { HelloSignService } from '@app/services/hello-sign.service';
import { LoadingIndicatorService } from '@app/services/loading-indicator.service';
import { BookingService } from '@app/services/booking.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  @HostBinding('class') class = 'page-body-config';

  petTileList: ParsedPet[];
  locationTileList: FranchiseLocation[];

  marketingTileList$: Observable<MarketingTile[]>;

  constructor(
    private _analytics: AnalyticsService,
    private myProfileService: MyProfileService,
    private helloSignService: HelloSignService,
    private loadingIndicatorService: LoadingIndicatorService,
    private getMarketingTilesQuery: GetMarketingTilesGQL,
    public bookingService: BookingService,
    public petService: PetService
  ) {}

  ngOnInit(): void {
    this._analytics.logScreen('landingPage');
    this._fetchData();
  }

  get showTermPolicyFormsError(): boolean {
    if (!this.myProfileService.preferredLocation) {
      return false;
    }
    return (
      this.petTileList &&
      this.petTileList.length > 0 &&
      !this.helloSignService.signedTermPolicyForm
    );
  }
  // Private Methods
  // ------------------------------------------------------------------------------------

  private _fetchData() {
    this.loadingIndicatorService.show();

    // HeloSign
    this.helloSignService.fetchForms();
    // Pet Info
    this.petService.fetchPetList();
    // Locations
    this.myProfileService.fetchLocationList();
    // Booking Info
    this.bookingService.fetchBookings(false);
    // Marketing Tiles
    this.marketingTileList$ = this.getMarketingTilesQuery.fetch().pipe(
      map((res) => {
        return res.data.getMarketingTiles;
      }),
      take(1)
    );

    //
    this.petService.petList$.pipe(skip(1)).subscribe((petList) => {
      this.loadingIndicatorService.hide();
      this.petTileList = petList;
    });
    this.myProfileService.locationList$.subscribe(
      (locationTileList) => (this.locationTileList = locationTileList)
    );
  }
}
